import script from "./novaRecuperanda.vue?vue&type=script&setup=true&lang=js"
export * from "./novaRecuperanda.vue?vue&type=script&setup=true&lang=js"

import "./novaRecuperanda.vue?vue&type=style&index=0&id=5264fff8&lang=css"

const __exports__ = script;

export default __exports__